import React from 'react';
import { FaSearch } from 'react-icons/fa';

const SearchBar = ({ id, handleSearch }) => (
  <div>
    <label htmlFor="search-patient-id" className="block text-lg font-semibold text-blue-800 mb-2">
      Search Patient by ID
    </label>
    <div className="relative">
      <input
        type="text"
        id="search-patient-id"
        name="searchPatientId"
        className="w-full pl-12 pr-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
        placeholder="Enter Patient ID"
        value={id}
        onInput={handleSearch}
      />
      <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl" />
    </div>
  </div>
);

export default SearchBar;